import { render, staticRenderFns } from "./Dashboard.html?vue&type=template&id=12804748&external"
import script from "./Dashboard.js?vue&type=script&lang=js&external"
export * from "./Dashboard.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports